// src/theme/theme.js
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#0074cc', // Blue
    },
    secondary: {
      main: '#00bcd4', // Teal
    },
  },
  shape: {
    borderRadius: 12,
  },
});

export default theme;
